import { ClientInvoiceGroupingMode } from '../models/client-invoices.model';

/** Lookup InvoiceGroupingOptionId: 1 = Subclient, 2 = Client. */
export const INVOICE_GROUPING_OPTION_SUB_CLIENT = 1;
export const INVOICE_GROUPING_OPTION_MASTER_CLIENT = 2;

function normalizeGroupingToken(raw: string): string {
  return raw.trim().toLowerCase().replace(/[\s_-]/g, '');
}

/**
 * Parse invoices `groupingMode` from the gateway.
 * Canonical names are Client and Subclient (also accepts API SubClient / MasterClient and IDs 1 / 2).
 */
export function parseClientInvoiceGroupingMode(raw: unknown): ClientInvoiceGroupingMode | null {
  if (raw == null) return null;

  if (typeof raw === 'object') {
    const o = raw as Record<string, unknown>;
    const fromName = parseClientInvoiceGroupingMode(o['name'] ?? o['Name']);
    if (fromName) return fromName;
    return groupingModeFromOptionId(
      Number(o['invoiceGroupingOptionId'] ?? o['InvoiceGroupingOptionId'])
    );
  }

  if (typeof raw === 'number' && Number.isFinite(raw)) {
    return groupingModeFromOptionId(raw);
  }

  const s = String(raw).trim();
  if (!s) return null;

  const asId = Number(s);
  if (Number.isInteger(asId) && asId > 0) {
    const fromId = groupingModeFromOptionId(asId);
    if (fromId) return fromId;
  }

  const token = normalizeGroupingToken(s);
  if (token === 'subclient') return 'SubClient';
  if (token === 'masterclient' || token === 'client') return 'MasterClient';
  return null;
}

export function groupingModeFromOptionId(
  id: number | null | undefined
): ClientInvoiceGroupingMode | null {
  if (id === INVOICE_GROUPING_OPTION_MASTER_CLIENT) return 'MasterClient';
  if (id === INVOICE_GROUPING_OPTION_SUB_CLIENT) return 'SubClient';
  return null;
}
